var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.verifyType
        ? _c("div", [
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "25px",
                  color: "rgba(0, 0, 0, 0.85)",
                  "font-weight": "800",
                  "margin-bottom": "20px",
                  "margin-top": "15px"
                }
              },
              [_vm._v(_vm._s(_vm.language["system.chooseLoginVerifyType"]))]
            ),
            !!this.phone
              ? _c("p", { on: { click: _vm.phoneVerify } }, [
                  _c("img", {
                    staticStyle: { width: "12%" },
                    attrs: {
                      alt: "example",
                      src: require("@/assets/login-mail-verify.svg")
                    }
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "20px",
                        "font-weight": "500",
                        "padding-left": "20px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.language["system.loginPhoneVerify"]))]
                  )
                ])
              : _vm._e(),
            !!this.email
              ? _c("p", { on: { click: _vm.mailVerify } }, [
                  _c("img", {
                    staticStyle: { width: "12%" },
                    attrs: {
                      alt: "example",
                      src: require("@/assets/login-phone-verify.svg")
                    }
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "20px",
                        "font-weight": "500",
                        "padding-left": "20px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.language["system.loginEmailVerify"]))]
                  )
                ])
              : _vm._e(),
            !this.email && !this.phone
              ? _c("p", [
                  _vm._v(
                    _vm._s(_vm.language["system.loginVerify.notPhoneAndMail"])
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _c("verify-phone", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.verifyType == "phone",
            expression: "verifyType=='phone'"
          }
        ],
        ref: "verifyPhone",
        on: {
          validateFail: _vm.validateFail,
          fail: _vm.requestFailed,
          success: _vm.requestSuccess
        }
      }),
      _c("verify-mail", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.verifyType == "mail",
            expression: "verifyType=='mail'"
          }
        ],
        ref: "verifyMail",
        on: {
          validateFail: _vm.validateFail,
          fail: _vm.requestFailed,
          success: _vm.requestSuccess
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }